import React from 'react';
import MedicinesPage from './MedicinesPage';
import MedicinesMobilePage from './MedicinesMobilePage';
import ResponsiveWrapper from '../../components/common/ResponsiveWrapper';


const MedicinesPageWrapper: React.FC = React.memo(() => {
  return (
    <>
      <ResponsiveWrapper
        mobileComponent={MedicinesMobilePage}
        desktopComponent={MedicinesPage}
      />
    </>
  );
});

MedicinesPageWrapper.displayName = 'MedicinesPageWrapper';

export default MedicinesPageWrapper; 